<template>

	<div class="pagination-buttons-wrapper">
		<div class="row pagination-buttons-group">
			<AppPaginationButton
				v-for="button in buttons"
				:value="button.value"
				:active="activePage === Number(button.value)"
				@click="clickBtn(button.targetPage || button.value)"
			/>
		</div>
	</div>

</template>

<script>
import AppPaginationButton from "@/shared/components/AppPaginationButton.vue";

import {formatDateTime} from "@/shared/helpers/dates";
import {useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		return {getString: languageStore.getString, formatDateTime}
	},
	name: "AppPaginationButtonsGroup",
	components: { AppPaginationButton },
	emits: ['changed-page'],
	data() {
		return {
			activePage: 1,
		};
	},
	props: {
		pagesNumber: {
			type: Number,
			required: true
		},
	},
	computed: {
		buttons() {
			return this.createButtonsArray();
		},
	},
	methods: {
		clickBtn(btnVal) {
			this.activePage = btnVal;
			this.$emit('changed-page', btnVal);
		},
		createButtonsArray() {
			let buttonsArray = [];
			if(!this.pagesNumber) { return []; }
			if(this.pagesNumber <= 7) {
				for (let i = 1; i <= this.pagesNumber; i++) {
					buttonsArray.push({ value: i });
				}
			} else {
				buttonsArray.push({ value: 1 });
				if(this.activePage <= 4) {
					for (let i = 2; i <= 5; i++) {
						buttonsArray.push({ value: i });
					}
					let targetPage = Math.round((this.pagesNumber - 5)/2) + 5;
					buttonsArray.push({ value: 0, targetPage: targetPage });
				} else if(this.activePage >= this.pagesNumber - 3) {
					let targetPage = Math.round((this.pagesNumber - 4)/2);
					buttonsArray.push({value: 0, targetPage: targetPage});
					for (let i = this.pagesNumber - 4; i < this.pagesNumber; i++) {
						buttonsArray.push({value: i});
					}
				} else {
					let targetPrevPage = Math.round((this.activePage - 1)/2);
					buttonsArray.push({value: 0, targetPage: targetPrevPage});
					buttonsArray.push({value: this.activePage - 1});
					buttonsArray.push({value: this.activePage});
					buttonsArray.push({value: this.activePage + 1});
					let targetNextPage = this.pagesNumber - Math.round((this.pagesNumber - this.activePage - 1)/2);
					buttonsArray.push({value: 0, targetPage: targetNextPage});
				}
				buttonsArray.push({value: this.pagesNumber});
			}
			return buttonsArray;
		},
	}
}

</script>

<style lang="scss" scoped>

.pagination-buttons-group {
	justify-content: flex-end;
}

</style>